import React from "react";
import ScrollButton from "../ScrollButton/";
import { makeStyles } from '@material-ui/styles'
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";
import "./TabsSections.scss";

const useStyles = makeStyles({
  normal: {
    fontSize: 11
  },
  bolded: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  degraded: {
    fontSize: 11,
    color: 'rgb(33, 37, 41)'
  },
  container: {
    display: 'flex',
    justifyContent: 'center'
  },
  justify: {
    textAlign: 'justify',
  }
})

var showButton = function myFunction() {
  var container = document.getElementById("containerElement");
  var button = document.getElementById("scroll-button");

  if (container.scrollTop < 600 && button.className === ""){
    button.className = "button hidden";
  }
  else if (container.scrollTop > 600) {
    button.className = "button visible";
  }
  else if (button.className === "button visible" && container.scrollTop < 400) {
    button.className = "button visible change";
    setTimeout(()=>{button.className = "button hidden"}, 800);
  }
}

function Terms(props) {

  const classes = useStyles()

  return (
    <div className="panel_content_text">
      <ScrollButton/>
      <Element
        name="test7"
        className="element"
        id="containerElement"
        style={{
          position: "relative",
          height: '60vh',
          overflow: 'scroll',
        }}
        onScroll={showButton}
      >
        
        
        <p className={classes.container}>
            <strong className={classes.normal}>
                <u className={classes.bolded}>Términos y Condiciones</u>
            </strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>El presente acuerdo describe los términos y condiciones de los servicios prestados por TGC INTERNET GROUP, S. DE R.L. DE C.V. (en adelante referida en estos términos y condiciones como “CONTACTA ABOGADO”) dentro de la página web https://contactaabogado.com
                (en adelante el “Sitio” / “https://contactaabogado.com”)</span> <span className={classes.degraded}> con domicilio en Hamburgo 70, Interior 201, Colonia Juárez, Alcaldía Cuauhtémoc, C.P. 06600, Ciudad de México</span>
            <span className={classes.normal}>. CONTACTA ABOGADO es una sociedad debidamente constituida de conformidad con las leyes de los Estados Unidos Mexicanos que proporciona el servicio de intercambio y administración de información entre distintas personas físicas y morales que prestan
                algún tipo de servicio profesional (en adelante referidos como “Anunciantes”) y distintas personas físicas y morales que requieren los servicios prestados por los Anunciantes (en adelante referidos como “Clientes”) (en conjunto los “Usuarios”),
                así como diversas soluciones tecnológicas e informáticas para los Usuarios. Cualquier referencia relativa a TGC INTERNET GROUP, S. DE R.L. DE C.V. que se haga en el Sitio https://contactaabogado.com o en estos términos y condiciones se entenderá extensiva a cualquiera de
                las subsidiarias, partes relacionadas o funcionarios de estas.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Al utilizar los servicios del Sitio https://contactaabogado.com, los Usuarios reconocen y aceptan que los siguientes términos y condiciones tienen carácter obligatorio y vinculante. Asimismo, aceptan y reconocen las responsabilidades que deriven del presente acuerdo.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Por tanto, los Usuarios al aceptar estos términos y condiciones reconocen que el presente acuerdo regirá la relación contractual entre las partes, las responsabilidades, y cualquier otra consecuencia jurídica que pudiera derivar del presente acuerdo,
                entre los Usuarios y CONTACTA ABOGADO.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios para utilizar los servicios del Sitio https://contactaabogado.com deberán leer y aceptar estos términos y condiciones, en el caso contrario deberán abstenerse de utilizar el Sitio https://contactaabogado.com.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.bolded}>I.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Capacidad y Legitimación</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Usuarios</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Para usar el Sitio https://contactaabogado.com los Usuarios deberán contar con capacidad legal para contratar. No podrán utilizar el Sitio https://contactaabogado.com las personas que no tengan capacidad legal para obligarse, los menores de edad y aquellos Usuarios que hubieran sido suspendidos o inhabilitados
                por CONTACTA ABOGADO.</span>
        </p>
        
        <p className={classes.justify}>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>En caso de que los Usuarios sean personas físicas, reconocen y aceptan que de conformidad con las leyes del país en que realizan y utilizan los Servicios del Sitio https://contactaabogado.com, tienen la capacidad legal suficiente para obligarse en los términos del presente acuerdo.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>En caso de que los Usuarios sean personas morales, las personas que realicen el registro deberán contar con la facultad legal para obligarlas, por tanto, las personas que realizan el registro en representación de las personas morales reconocen y aceptan
                que los Usuarios personas morales, cuentan con la capacidad, conocimientos, experiencia, infraestructura, permisos, licencias, autorizaciones, elementos y personal propios, que les permiten obligarse de conformidad con los presentes términos y
                condiciones.</span>
        </p>
        <p className={classes.justify}>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Anunciantes</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>El Sitio https://contactaabogado.com cuenta con dos tipos de Anunciantes: (i) Abogados Independientes y (ii) Despachos y/o Firmas.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Para usar el Sitio https://contactaabogado.com los Anunciantes deberán contar con capacidad legal para contratar. Asimismo, deberán contar con cédula profesional expedida por la Secretaria de Educación Pública, o cualquier documento que avale que pueden ejercer su profesión.
                CONTACTA ABOGADO podrá solicitar dicho documento en cualquier momento a los Anunciantes.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Para mayor información, los usuarios del Sitio https://contactaabogado.com podrán corroborar el número de cédula profesional y/o nombre proporcionado por los Anunciantes en la página</span> <a href="https://www.cedulaprofesional.sep.gob.mx/cedula/presidencia/indexAvanzada.action" target="_blank" className={classes.normal}>https://www.cedulaprofesional.sep.gob.mx/cedula/presidencia/indexAvanzada.action</a>
            <span className={classes.normal}>.</span>
        </p>
        <p className={classes.justify}>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.bolded}>II.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Registro y Contraseña</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Anunciantes deberán llenar el registro con su información personal o corporativa, la cual debe ser verdadera, actual, precisa y completa. Los Anunciantes responden por la información falsa, anticuada, imprecisa o incompleta ante, según sea el
                caso, los Clientes, CONTACTA ABOGADO o cualquier otra entidad o persona a la que le pueda causar un daño el que los Usuarios hubieran proporcionado información de esta naturaleza.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO estará facultado en cualquier momento a solicitar la aclaración de la información de los Anunciantes, y en su caso, para prohibir, remover y bloquear el registro a los Anunciantes que no cumplan con lo establecido en el párrafo anterior.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Clientes deberán también llenar su registro con su información personal.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Una vez registrado, CONTACTA ABOGADO proporcionará a sus Usuarios un número de cuenta y una contraseña que les permitirá acceder al Sitio https://contactaabogado.com. El uso de dichos datos es responsabilidad de los Usuarios y deberán cuidarlo y protegerlo.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>El número de cuenta y la contraseña son intransferibles y sólo podrán hacer uso de estos, aquellas personas que se hubieran registrado en el Sitio https://contactaabogado.com de conformidad con lo expuesto en el párrafo que precede. La obtención del número de cuenta y de la
                contraseña responsabiliza a los Usuarios en el uso de las mismas, ya que son únicas y personales, y por tanto sólo los Usuarios registrados podrán tener acceso al Sitio https://contactaabogado.com.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios se comprometen a utilizar su contraseña y número de cuenta de conformidad con la ley, la moral y las buenas costumbres. En el caso de que los Usuarios utilicen la contraseña y el número de cuenta en contravención a lo anterior, serán
                responsables por el mal uso de las mismas. Pueden controlar su perfil de Usuario y como interactúa con el servicio cambiando la configuración de su perfil.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Anunciantes serán directamente responsables frente a los Clientes de los datos que establezcan en el registro, y al aceptar estos términos y condiciones se comprometen a sacar en paz y a salvo a CONTACTA ABOGADO de cualquier reclamación que se
                pudiera dar referente a la información proporcionada por los Anunciantes.</span>
        </p>
        <p className={classes.justify}>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.bolded}>III.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Privacidad de Datos Personales y Uso de Información</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Para hacer uso del Sitio https://contactaabogado.com los Clientes deberán ingresar su información en el mismo. CONTACTA ABOGADO a través de su plataforma dará a conocer la información ingresada por los Usuarios a los Clientes y Anunciantes. Para estos efectos, CONTACTA ABOGADO
                almacena la información en servidores que mantienen los estándares de seguridad y protección tecnológica de conformidad con sus capacidades y las políticas y estándares internos.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>La información proporcionada por los Usuarios será tratada como confidencial y sólo se dará a conocer a terceras personas para cumplir los fines de los servicios de CONTACTA ABOGADO y en los casos establecidos por la Ley Federal de Protección de Datos
                Personales en Posesión de Particulares, actuando de buena fe, si tenemos la creencia de que dicha divulgación es razonablemente necesaria para: (a) cumplir con cualquier proceso legal, incluyendo de manera enunciativa más no limitativa, entre otros, una orden judicial ejecutoria o una
                citación legal de un tercero; (b) hacer cumplir este Acuerdo; (c) responder a reclamos de que cualquier contenido viola los derechos de terceros; o (d) proteger los derechos, propiedad o seguridad personal de CONTACTA ABOGADO y sus Usuarios. CONTACTA
                ABOGADO tomará todas las medidas razonables para salvaguardar toda la información obtenida.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios al aceptar estos términos y condiciones reconocen que CONTACTA ABOGADO no será responsable en el caso en que, por medio de una infiltración, virus o cualquier conducta maliciosa algún tercero sustraiga información confidencial del Sitio https://contactaabogado.com.</span>
        </p>
        <p className={classes.justify}>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO tratará los datos personales de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de Particulares. Para más información, visite nuestro Aviso de Privacidad.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios al aceptar estos términos y condiciones autorizan a CONTACTA ABOGADO para hacer uso de esta información con el objeto de prestar los servicios de contratación, asesoría, intercambio y administración de información, pago de servicios y
                administración de servicios, así como cualquier otro permitido por ley.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Asimismo, los Usuarios autorizan a CONTACTA ABOGADO para realizar una base de datos que contenga su información con el objeto de prestar los servicios mencionados en el párrafo anterior.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO utilizará la información ingresada en el Sitio https://contactaabogado.com con el objeto de prestar los servicios antes descritos, y no será responsable por el uso que hagan terceras personas de la mencionada información.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios al ingresar su información en el Sitio https://contactaabogado.com, reconocen que CONTACTA ABOGADO puede alterar dicha información cuando se tengan indicios claros que la información proporcionada por los Usuarios es incompleta, incorrecta o no sea verdadera. Lo
                anterior sin perjuicio de que CONTACTA ABOGADO pueda dar de baja al Usuario por ingresar información de esta naturaleza.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios al ingresar su información en el Sitio https://contactaabogado.com se encargan de clasificarse, por lo que liberan de cualquier responsabilidad a CONTACTA ABOGADO por esa clasificación.</span>
        </p>
        <p className={classes.justify}>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.bolded}>IV.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Derecho de CONTACTA ABOGADO para la Cancelación de Registros</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios tendrán prohibido: (i) ingresar información falsa dentro del Sitio https://contactaabogado.com; (ii) publicar comentarios agresivos e insultantes; (iii) explotar los servicios de CONTACTA ABOGADO de una manera no autorizada y en contra de éstos términos y condiciones;
                (iv) hacer uso del Sitio https://contactaabogado.com para realizar prácticas de competencia desleal, con fines fraudulentos o cualquier otra que vaya en contra de la ley o las buenas costumbres; (v) publicar o vender servicios prohibidos por la ley; y (vi) utilizar la información
                de los Anunciantes o Clientes para fines distintos a los establecidos en los presentes términos y condiciones.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios que sean sorprendidos realizando alguna de las conductas descritas en el párrafo precedente serán dados de baja del Sitio https://contactaabogado.com, sin perjuicio de las acciones civiles o penales en las que pudieren incurrir.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.bolded}>V.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Modificaciones del Acuerdo</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO podrá modificar en todo momento los términos y condiciones haciéndosele saber a sus Usuarios a través del Sitio https://contactaabogado.com las modificaciones que hubiera realizado. Las modificaciones a los términos y condiciones entrarán en vigor 5 (cinco)
                días hábiles después de su publicación en el Sitio https://contactaabogado.com. En el caso de que los Usuarios no estén de acuerdo con las modificaciones, deberán de dejar de utilizar el Sitio https://contactaabogado.com y si es el caso, podrán dar aviso de esta situación a CONTACTA ABOGADO para proceder
                con la baja de su cuenta. CONTACTA ABOGADO entenderá que los Usuarios aceptan los términos y condiciones si continúan utilizando sus cuentas y contraseñas para ingresar al Sitio https://contactaabogado.com y utilizar los Servicios.</span>
        </p>
        <p className={classes.justify}>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.bolded}>VI.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Contratación de Servicios</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Clientes al registrarse en el Sitio https://contactaabogado.com contratan con CONTACTA ABOGADO los servicios de intermediación e intercambio de información, entendiéndose por éstos aquellos en los que los Anunciantes
                ingresan en el Sitio https://contactaabogado.com cierta información personal o de
                negocios con el objeto de que sea conocida por los Clientes, y su vez los Clientes ingresan en el Sitio https://contactaabogado.com cierta información personal y de negocios para que sea conocida por los Anunciantes. Para estos efectos, CONTACTA ABOGADO sólo fungirá como
                intermediario entre los Clientes y los Anunciantes para dar a conocer la información ingresada en el Sitio https://contactaabogado.com a los Clientes o a los Anunciantes, según sea el caso, y no se hace responsable en ningún momento del resultado de la relación contractual
                o de negocios establecida entre el Cliente y el Anunciante, ya que en ningún momento tendrá participación en ella.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Servicios Clientes</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los servicios que CONTACTA ABOGADO ofrecen a los Clientes serán gratuitos.&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Servicios Abogados</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Abogados tendrán la opción de optar por una Membresía Freemium (que será gratuita) o por una Membresía Premium Abogado (que tendrá un costo).</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los servicios que ofrece CONTACTA ABOGADO en la Membresía Freemium serán los siguientes:</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Perfil profesional Premium Abogado.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación de artículos de su materia de especialidad. (1 artículo x 3 meses).</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Con relación a los productos y servicios que ofrece CONTACTA ABOGADO en la Membresía Premium Abogado son los siguientes:</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>PRODUCTOS:</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Perfil profesional Premium Abogado.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Posicionamiento y presencia Online dentro y fuera de la plataforma.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Sitio web con dominio personalizado y branding de abogado.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación de artículos de su materia de especialidad.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación de imágenes y videos relacionados a su experiencia profesional.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Generador de propuestas comerciales para sus clientes potenciales.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Acceso a la comunidad de usuarios para interactuar con clientes potenciales.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>SERVICIOS:</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Acceso a Webinars exclusivos por parte de nuestros expertos legales y de Marketing Digital (Contacta Abogado Academy)</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Soporte técnico de nuestros especialistas en Marketing Digital.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Campañas personalizadas para invitar a tus clientes a crear valoraciones y recomendaciones de tu perfil.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Servicios Despachos</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Despachos tendrán la opción de optar por una Membresía Freemium (que será gratuita) o por una Membresía Premium Despacho (que tendrá un costo).</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los servicios que ofrece CONTACTA ABOGADO en la Membresía Freemium serán los siguientes:</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Perfil profesional Premium Despacho.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación ubicación matriz.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación de artículos de su materia de especialidad. (1 artículo x 3 meses).</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Con relación a los productos y servicios que ofrece CONTACTA ABOGADO en la Membresía Premium Despacho son los siguientes:</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>PRODUCTOS:</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Perfil profesional completo al Titular de Despacho</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Hasta 10 perfiles de socios y/o asociados dentro del perfil de Despacho.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Posicionamiento y presencia Online dentro y fuera de la plataforma.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Sitio web con dominio personalizado y branding de abogado.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación de hasta 5 ubicaciones/sedes a nivel nacional.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación de artículos de los miembros del despacho.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Publicación de imágenes y videos relacionados a su experiencia profesional.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Generador de propuestas comerciales para sus clientes potenciales.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Acceso a la comunidad de usuarios para interactuar con clientes potenciales.</span>
        </p>        
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>SERVICIOS:</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Acceso a Webinars exclusivos por parte de nuestros expertos legales y de Marketing Digital (Contacta Abogado Academy)</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Soporte técnico de nuestros especialistas en Marketing Digital.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Campañas personalizadas para invitar a tus clientes a crear valoraciones y recomendaciones de tu perfil.</span>
        </p>
        <p>
            <br />
        </p>        
        <p className={classes.justify}>
            <strong className={classes.bolded}>VII.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tarifas y Forma de Pago</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Servicios Clientes</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los servicios de CONTACTA ABOGADO para los Clientes serán gratuitos.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Servicios Abogados</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los servicios de la Membresía Freemium serán gratuitos.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO cobrará por los servicios de la Membresía Premium Abogado, mensualmente, la cantidad de $1,299.00 (Mil Doscientos Noventa y Nueve Pesos 00/100 M.N.) más el correspondiente Impuesto sobre el Valor Agregado (IVA), dando un total anual de $15,588.00 (Quince Mil Quinientos Ochenta y Ocho Pesos 00/100 M.N.) más el correspondiente Impuesto sobre el Valor Agregado (IVA). El pago será Domiciliado a Tarjeta de Crédito y/o Tarjeta de Débito.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO cobrará por los servicios de la Membresía Premium Abogado, la cantidad de $12,470.40 (Doce Mil Cuatrocientos Setenta Pesos 40/100 M.N.) más el correspondiente Impuesto sobre el Valor Agregado (IVA) únicamente si se realiza el pago anual en una sola exhibición. El pago deberá ser con Tarjeta de Crédito y/o Tarjeta de Débito y/o Transferencia Bancaria en una sola exhibición.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Servicios Despachos</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los servicios de la Membresía Freemium serán gratuitos.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO cobrará por los servicios de la Membresía Premium Despacho, mensualmente, la cantidad de $1,999.00 (Mil Novecientos Noventa y Nueve Pesos 00/100 M.N.) más el correspondiente Impuesto sobre el Valor Agregado (IVA), dando un total anual de $23,988.00 (Veintitrés Mil Novecientos Ochenta y Ocho Pesos 00/100 M.N.) más el correspondiente Impuesto sobre el Valor Agregado (IVA). El Pago será Domiciliado a Tarjeta de Crédito y/o Tarjeta de Débito.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO cobrará por los servicios de la Membresía Premium Despacho, la cantidad de $19,190.40 (Diecinueve Mil Ciento Noventa Pesos 40/100 M.N.) más el correspondiente Impuesto sobre el Valor Agregado (IVA) únicamente si se realiza el pago anual en una sola exhibición. El pago deberá ser con Tarjeta de Crédito y/o Tarjeta de Débito y/o Transferencia Bancaria en una sola exhibición.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Por lo anterior, CONTACTA ABOGADO se reserva el derecho de modificar, cambiar, agregar, o eliminar las tarifas vigentes, en cualquier momento, lo cual será notificado a los Usuarios, en la forma establecida en la Cláusula V; además, podrá modificar temporalmente las tarifas por sus servicios por razón de promociones, siendo efectivas estas modificaciones cuando se haga pública la promoción o se realice el anuncio en el Sitio https://contactaabogado.com.
            </span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Asimismo, CONTACTA ABOGADO se reserva el derecho de decidir, en cada momento, los servicios que se ofrecen a los Usuarios. De este modo, CONTACTA ABOGADO podrá, en cualquier momento, añadir nuevos productos y servicios a los ofertados actualmente. De igual forma, CONTACTA ABOGADO se reserva el derecho a retirar o dejar de ofrecer, en cualquier momento, y sin previo aviso, cualesquiera de los productos y servicios ofrecidos.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Forma de Pago</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>El pago de los servicios ofrecidos por CONTACTA ABOGADO se realizará dentro del Sitio https://contactaabogado.com, a través de la plataforma de pagos STRIPE.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Es por lo anterior, que nuestro Sitio https://contactaabogado.com no almacena ningún dato de pago o información bancaria de tipo alguno.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Sin embargo, nuestro Sitio https://contactaabogado.com sí almacena información para fines de facturación y manejo de Membresías, tales como:</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Nombre</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Apellido</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Razón social</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-RFC</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Domicilio fiscal</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>-Correo electrónico</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Todos los pagos de los servicios incluyen Comprobante fiscal. Los recibos de cobro emitidos incluirán el Impuesto al Valor Agregado.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>En el momento del cobro, de acuerdo con el plan y el método de pago que el Anunciante haya seleccionado, la factura se le enviará al</span>
            <span className={classes.normal}> e-mail que proporcionó cuando se registró en el Sitio https://contactaabogado.com de CONTACTA ABOGADO, para ello, el Anunciante en su primera compra tendrá que llenar los datos de facturación solicitados en el Sitio https://contactaabogado.com.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Todos los cobros son recurrentes. El Contrato de los servicios de CONTACTA ABOGADO es forzosamente anual, dando la Opción de Cierre de Venta sólo el primer mes sin costo. Si decide realizar el pago cada mes, el pago se realizará mensualmente por 12 (doce) meses, no obstante, si usted no realiza la cancelación con anticipación, se le realizará automáticamente el cargo mes por mes hasta que decida cancelar los Servicios de CONTACTA ABOGADO. Si decide realizar el pago anualmente en una sola exhibición, éste deberá efectuarse la misma fecha de cada año hasta que decida cancelar los Servicios de CONTACTA ABOGADO, ya que, si Usted no avisa con anticipación la cancelación de los servicios, automáticamente se le efectuará el cargo anual.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p>
            <span className={classes.normal}>En caso de que hubiera facturas o saldos anteriores impagos,</span>
            <span className={classes.normal}>CONTACTA ABOGADO enviará un e-mail a la dirección de correo electrónico que el Anunciante proporcionó, señalando el día del vencimiento de la factura informando a los Anunciantes que aún tengan su factura pendiente de pago.</span>
            <span className={classes.normal}>Se podrá pagar el total del costo de los servicios o sólo lo correspondiente a períodos anteriores.</span>
            <span className={classes.normal}>Los cargos por mora empezarán a correr desde la fecha de vencimiento del plazo indicado.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Asimismo, los Anunciantes podrán realizar pagos de los servicios ofrecidos por CONTACTA ABOGADO anticipadamente, recibirán su aviso de facturación</span> <span className={classes.normal}>por e-mail</span> <span className={classes.normal}>y los mismos se acreditarán en el Sitio&nbsp;</span> <a href="https://contactaabogado.com/" target="_blank" className={classes.normal}>https://contactaabogado.com</a> <span className={classes.normal}>(sección Cobro/Factura) como saldo a favor.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Todos los cobros y las facturas también se verán reflejadas en el panel de control dentro del Sitio https://contactaabogado.com de CONTACTA ABOGADO, para que el Anunciante pueda descargar facturas, cambiar el método de pago y visualizar la próxima fecha de Cobro/Factura.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Para más información sírvase revisar nuestro Aviso de Privacidad.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>La plataforma de pagos STRIPE brindará la posibilidad a los Usuarios de pagar por medio de Tarjetas de Crédito, Débito o Servicios Visa, MasterCard, American Express.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Asimismo, STRIPE otorga la posibilidad de realizar el pago mediante otras opciones, para más información acerca de los métodos de pago que ofrece STRIPE sírvase consultar la página</span> <a href="https://stripe.com/es-mx/payments/features#cards" target="_blank" className={classes.normal}>https://stripe.com/es-mx/payments/features#cards</a><span className={classes.normal}>.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Para más información sírvase consultar la página web de STRIPE:</span> <a href="https://stripe.com/es-mx" target="_blank" className={classes.normal}>https://stripe.com/es-mx</a><span className={classes.normal}>.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>En caso de haberse facturado cargos que no hubiesen correspondido, se requiera la cancelación de facturas o algún dato contable, los Anunciantes deberán comunicarse con nuestro equipo de Atención al Cliente para resolver dicha cuestión vía telefónica:
                52-55-41-60-60-61.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>VIII.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sitio web con Dominio Personalizado</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Uno de los Productos ofrecidos por CONTACTA ABOGADO en la Membresía Premium Abogado y/o en la Membresía Premium Despacho es la creación de un Sitio web con dominio personalizado. 
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Debido a lo anterior, CONTACTA ABOGADO comprará a u registrador de dominios el Dominio indicado de forma expresa por el Anunciante, este Dominio deberá estar disponible, CONTACTA ABOGADO no se hace responsable de la disponibilidad del mismo, en caso de que este Dominio no esté disponible, el Anunciante deberá elegir otro e indicárselo de forma expresa a CONTACTA ABOGADO.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO creará el Sitio Web con un software propiedad de CONTACTA ABOGADO, todos los derechos de propiedad intelectual de los Sitios Web creados por CONTACTA ABOGADO son propiedad de éste.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                El producto ofrecido por CONTACTA ABOGADO, así como los demás productos y servicios ofrecidos por éste, se mantendrá vigente el mismo tiempo en que continúa vigente la Membresía Premium Abogado y/o en la Membresía Premium Despacho, por lo tanto, CONTACTA ABOGADO retirará el software y todas las obras cuya propiedad intelectual pertenezca a CONTACTA ABOGADO y que se hayan utilizado para la creación del Sitio Web.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Si la Membresía Premium Abogado y/o en la Membresía Premium Despacho termina su vigencia, el Anunciante podrá solicitar, de manera gratuita y expresa, a CONTACTA ABOGADO la transferencia de su Dominio, sin incluir el diseño de la página web, para lo cual deberá seguir el siguiente procedimiento:
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>La transferencia de dominio consta de dos pasos</strong>
        </p>
        <p>
            <br />
        </p>
        <ul>
            <li>
                <p className={classes.justify}>
                    <span className={classes.normal}>Prepara la transferencia en el proveedor actual y acceder al código de autorización.</span>
                </p>
            </li>
            <li>
                <p className={classes.justify}>
                    <span className={classes.normal}>Inicia la transferencia y autorízala mediante el código de autorización</span>
                </p>
            </li>
        </ul>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO deberá preparar la transferencia de Dominio; en función de la extensión de dominio (.mx, .com, .org, etc.) se deben cumplir ciertos requisitos antes de poder acceder al código de autorización y transferir tu dominio a IONOS.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Ciertos dominios deben estar registrados, como mínimo, con 60 días antes de poder transferirlos a otro usuario. Se trata de una regulación de la ICANN vinculante para todos los proveedores. Esta regulación vale para las siguientes extensiones de dominio:
            </span>
        </p>
        <p>
            <br />
        </p>
        <ul>
            <li>
                <p className={classes.justify}>
                    <span className={classes.normal}>Dominios de nivel superior genéricos: .com / .net /.org / .biz / .info / .name / etc.</span>
                </p>
            </li>
            <li>
                <p className={classes.justify}>
                    <span className={classes.normal}>Nuevos dominios de nivel superior (nTLD): .photo / .web / .online / etc.</span>
                </p>
            </li>
        </ul>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Por razones de seguridad, para los dominios de nivel superior genéricos (p.ej., .com, .net o .org) el bloqueo de transferencia (Transfer Lock) está activado.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Antes de poder iniciar la transferencia de Dominio, CONTACTA ABOGADO debe desactivar el bloqueo. Este es un proceso que se realiza desde la configuración del proveedor del dominio.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Después de desactivar el bloqueo de transferencia, se puede acceder al código de autorización. Este código de autorización se obtiene desde las configuraciones del proveedor del dominio.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Este Código de autorización es el que CONTACTA ABOGADO deberá compartir con el Anunciante para poder hacer la transferencia.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>Iniciar la transferencia</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                El Anunciante que recibirá el Dominio tendrá que iniciar sesión en la consola del proveedor que haya contratado.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                En la consola tendrá una sección para transferencia de dominios, en la cual podrá seleccionar el paquete que haya o este por contratar para el Dominio en cuestión.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Una vez seleccionado el paquete, se le pedirá al Anunciante que escriba el Dominio a transferir. Cuando se haya localizado el Dominio y se haya seleccionado la opción de transferir se le pedirá que introduzca el código de autorización, el cual CONTACTA ABOGADO debió compartir con anterioridad. 
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Posteriormente se le pedirá que realice las configuraciones de DNS, y marcar que es el dueño y está autorizado para hacer la transferencia del Dominio.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                El Anunciante sólo contará con 15 días hábiles contados a partir del día siguiente a la terminación de la vigencia de su Membresía Premium Abogado y/o en la Membresía Premium Despacho para solicitar de manera expresa la transferencia de su Dominio.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO no se hace responsable de la vigencia de la compra del Dominio y de la disponibilidad del mismo una vez que la Membresía Premium Abogado y/o en la Membresía Premium Despacho haya perdido su vigencia.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>IX.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Comunidad</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                El Sitio https://contactaabogado.com tiene un foro público denominado “Comunidad” en donde los Clientes podrán realizar consultas a los Anunciantes, éstos pueden decidir contestar o no las consultas realizadas por los Clientes, a su vez, los Clientes podrán valorar como “útil” la información proporcionada por los Anunciantes.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Las consultas realizadas por los Clientes y las respuestas proporcionadas por los Anunciantes podrán observarse por todos los Usuarios del Sitio https://contactaabogado.com sujetándose a nuestro Aviso de Privacidad.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO no tiene control alguno sobre la eficacia, calidad, resultado, eficiencia, seguridad o legalidad del foro público denominado “Comunidad”. Por tanto, los Usuarios reconocen que CONTACTA ABOGADO no es responsable de las publicaciones en este foro.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>X.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Alcance de los Servicios</strong>
            <span className={classes.normal}>&nbsp;</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Este acuerdo no crea ni deberá entenderse como contrato de sociedad, de mandato, de franquicia, o relación laboral entre CONTACTA ABOGADO y los Usuarios. Por tanto, los Usuarios reconocen y aceptan que CONTACTA ABOGADO no es mandatario, comisionista,
                representante, franquiciatario, patrón, empleado, socio o accionista de los Clientes y/o los Anunciantes.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Asimismo, al aceptar estos términos y condiciones, los Usuarios reconocen y aceptan que CONTACTA ABOGADO no es parte en alguna operación, ni tiene control alguno sobre la eficacia, calidad, resultado, eficiencia, seguridad o legalidad de los servicios
                prestados por los Anunciantes a los Clientes. Por tanto, los Usuarios reconocen que CONTACTA ABOGADO no es responsable, ni forma parte de la relación comercial o profesional que llegaré a existir entre los Clientes y los Anunciantes.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Por tanto, CONTACTA ABOGADO, al no intervenir en la relación jurídica que se origine entre los Clientes y los Anunciantes por la información personal y de negocios que hubiera sido ingresada en el Sitio https://contactaabogado.com, los Usuarios al aceptar los presentes términos
                y condiciones se obligan a sacar a CONTACTA ABOGADO en paz y a salvo de cualquier demanda, reclamación y responsabilidad que pudieran surgir de la relación entre el Cliente y el Anunciante.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>No obstante, lo antes señalado, los Anunciantes al aceptar estos términos y condiciones reconocen y aceptan que existe una relación jurídica con CONTACTA ABOGADO y que se obligan a pagar las tarifas por los servicios prestados por CONTACTA ABOGADO
                y a cumplir las demás obligaciones que se deriven del presente acuerdo.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XI.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Seguridad y Uso de Cookies</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO realizará los esfuerzos razonables y de acuerdo con sus capacidades técnicas internas para proteger la información que los Usuarios coloquen en el Sitio https://contactaabogado.com a través del uso de distintos programas y softwares.</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>	</span>
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO no declara ni garantiza que el Sitio https://contactaabogado.com permanecerá libre de pérdidas, deterioro, ataques, virus, interferencia, piratería u otro tipo de penetración de seguridad, por lo tanto, los Usuarios (Clientes y Anunciantes) liberan a CONTACTA
                ABOGADO de todo tipo de responsabilidad relacionada con lo anteriormente mencionado.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>A efecto de mantener actualizado el Software de CONTACTA ABOGADO, se podrán ofrecer actualizaciones automáticas o manuales en cualquier momento y sin necesidad de notificarle a los usuarios.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Asimismo, CONTACTA ABOGADO hace del conocimiento de los Usuarios que nuestro Sitio https://contactaabogado.com utiliza Uso de cookies, web beacons y Links a sitios de terceros, para mayor información puede consultar nuestro Aviso de Privacidad y nuestra Política de Cookies.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XII.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prohibiciones</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios tendrán prohibido: (i) ingresar información falsa dentro del Sitio https://contactaabogado.com; (ii) publicar comentarios agresivos e insultantes; (iii) explotar los servicios de CONTACTA ABOGADO de una manera no autorizada y en contra de éstos términos y condiciones;
                (iv) hacer uso del Sitio https://contactaabogado.com para realizar prácticas de competencia desleal, con fines fraudulentos o cualquier otra que vaya en contra de la ley o las buenas costumbres o moral; (v) publicar o vender servicios prohibidos por la ley; y, (vi) utilizar
                la información de los Anunciantes o Clientes para fines distintos a los establecidos en los presentes términos y condiciones.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios que sean sorprendidos realizando alguna de las conductas descritas en el párrafo precedente serán dados de baja del Sitio https://contactaabogado.com, sin perjuicio de las acciones civiles o penales en las que pudieran incurrir.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios que infrinjan lo establecido en el presente apartado serán directamente responsables con CONTACTA ABOGADO, otros Usuarios o cualquier tercero que se pueda ver afectado por dicha infracción.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XIII.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Responsabilidad</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO sólo pone a disposición de los Usuarios un espacio virtual que les permite a Clientes y Anunciantes ofrecer su información de contacto para ponerse en comunicación para poder contratar servicios profesionales.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO no tiene control de los servicios ofrecidos por parte de los Anunciantes, por ello no será responsable respecto de la existencia, calidad o legitimidad de los servicios ofrecidos por los Anunciantes, así como de la capacidad para
                contratar de los Clientes o de la veracidad de la información ingresada por los Usuarios. Los Usuarios conocen y aceptan ser los únicos responsables por los servicios ofrecidos dentro del Sitio https://contactaabogado.com.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>El Sitio https://contactaabogado.com puede contener enlaces a sitios web de terceros en virtud que CONTACTA ABOGADO no tiene control sobre tales sitios, no será responsable por los contenidos, materiales, acciones y/o servicios prestados por los mismos, ni por daños o pérdidas
                ocasionadas por la utilización de éstos, causados directa o indirectamente. La presencia de enlaces a otros sitios web no implica una sociedad, relación, aprobación, respaldo de Contacta Abogado con dichos sitios y sus contenidos.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>En caso de que uno o más Usuarios o algún tercero inicien cualquier tipo de reclamo o acciones legales contra otro u otros Usuarios, todos y cada uno de los Usuarios involucrados en dichos reclamos o acciones eximen de toda responsabilidad a CONTACTA
                ABOGADO, así como a sus directores, ejecutivos, empleados, afiliados, agentes, Anunciantes, principales y dependientes.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XIV.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Violaciones del Sistema o Bases de Datos</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Está prohibido alterar, perturbar, dañar o realizar cualquier otra conducta que modifiqué el Sitio https://contactaabogado.com, el sistema de CONTACTA ABOGADO, el software, la operación y/o la base de datos propiedad de CONTACTA ABOGADO.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Las personas que sean sorprendidas realizando alguna de las actividades mencionadas en el párrafo anterior, serán responsable de las acciones legales que sean aplicables, así como de indemnizar a CONTACTA ABOGADO por los daños ocasionados.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XV.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sanciones</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios que realicen alguna conducta contraria a la ley, a las buenas costumbres, la moral o a estos términos y condiciones, estarán sujetos a la sanción relativa a la suspensión de la cuenta, sin perjuicio de cualquier otra acción legal que
                por derecho pudiera corresponder.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios al aceptar estos términos y condiciones aceptan y reconocen que CONTACTA ABOGADO podrá bloquear sus cuentas.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los Usuarios reconocen que CONTACTA ABOGADO no será acreedor de ninguna sanción por fallas en el sistema, modificación de la información, revelación de información y demás conductas aplicables de conformidad con el presente acuerdo.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XVI.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fallas en el Sistema</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>CONTACTA ABOGADO no será responsable de las fallas en el Sitio https://contactaabogado.com, en internet o en el sistema y no garantiza a los Usuarios el acceso ni el uso ininterrumpido del Sitio https://contactaabogado.com. En tales casos se procurará restablecerlo con la mayor celeridad posible sin que
                por ello pueda imputársele algún tipo de responsabilidad. Por lo anterior, los Usuarios al someterse a estos términos y condiciones aceptan que CONTACTA ABOGADO no es responsable por cualquier daño o perjuicio que se les pueda causar a los Clientes
                o Anunciantes por fallas en el sistema de cualquier naturaleza.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XVII.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Propiedad Intelectual</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>El uso no autorizado por parte de los Usuarios del Sitio https://contactaabogado.com, del software o de cualquier parte de los servicios de CONTACTA ABOGADO está estrictamente prohibido e infringe derechos de propiedad intelectual de CONTACTA ABOGADO y/o sus licenciantes, quedando
                sujetos a las penas civiles y/o penales, así como a las posibles indemnizaciones pecuniarias por los daños causados en virtud de la infracción a los derechos de autor y propiedad intelectual de CONTACTA ABOGADO.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los contenidos de las pantallas relativas a los servicios que CONTACTA ABOGADO ofrecen, así como también los programas, bases de datos, redes, archivos que permiten a los Usuarios acceder al Sitio https://contactaabogado.com, son propiedad exclusiva de CONTACTA ABOGADO y están
                protegidas por las leyes y los tratados internacionales de derechos de autor y propiedad intelectual, marcas, patentes, modelos y diseños industriales. El uso indebido de dicha información, así como la reproducción total o parcial de dichos contenidos
                quedan prohibidos, salvo autorización expresa y por escrito de CONTACTA ABOGADO.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>De igual forma, se hace del conocimiento de los Usuarios que la marca CONTACTA ABOGADO es una marca registrada ante las Autoridades correspondientes, por lo que se prohíbe expresamente su uso o reproducción parcial o total por parte de los Usuarios.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Asimismo, con relación a los derechos de propiedad intelectual del contenido que los Usuarios proporcionan, comparten o publican en el Sitio https://contactaabogado.com, CONTACTA ABOGADO no reclama la propiedad de este contenido. En lugar de ello, cuando los Usuarios proporcionan,
                comparten o publican contenido que se encuentra protegido por derechos de propiedad intelectual (como marcas, fotos o vídeos) en nuestro Sitio https://contactaabogado.com, de conformidad con los presentes Términos y Condiciones, los Usuarios nos conceden una licencia mundial,
                no exclusiva, transferible, sublicenciable y exenta de pagos por derechos de autor para alojar, distribuir, modificar, mantener, reproducir, mostrar o comunicar públicamente y traducir su contenido, así como para crear contenido derivado. Los
                Usuarios pueden eliminar el contenido o su cuenta en cualquier momento para dar por finalizada esta licencia. No obstante, el contenido seguirá siendo visible si lo han compartido con otras personas y estas no lo han eliminado.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                CONTACTA ABOGADO es propietario del Software y de la propiedad intelectual de las obras utilizadas para la creación de Sitios Web, de conformidad con la Cláusula VIII de estos términos y condiciones, por lo que prohíbe el uso no autorizado por parte de los Usuarios, quedando sujetos a las penas civiles y/o penales, así como a las posibles indemnizaciones pecuniarias por los daños causados en virtud de la infracción a los derechos de autor y propiedad intelectual de CONTACTA ABOGADO.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XVIII.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vigencia</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Los presentes Términos y Condiciones estarán vigentes y serán obligatorios y vinculantes para todos los Usuarios que tengan una cuenta y no soliciten su baja o cancelación.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Asimismo, la contratación de las Membresías por parte de los Anunciantes será obligatoriamente por un plazo de un (1) año. Si por algún motivo, los Anunciantes quieren dar por terminada su Membresía, con antelación al cumplimiento de ese período, CONTACTA ABOGADO hará el cobro correspondiente a los meses restantes para cumplir el plazo obligatorio y en caso de que se realicé el pago anual en una sola exhibición, CONTACTA ABOGADO no hará devolución alguna de la cantidad pagada por dicha Membresía.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                La renovación de las Membresías es automática, a menos que los Anunciantes soliciten su baja o cancelación de forma expresa a CONTACTA ABOGADO, con treinta (30) días de anticipación a la fecha en que deba efectuarse el pago.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XIX.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Atención</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Para cualquier duda o comentario relacionada con los servicios prestados por CONTACTA ABOGADO y detallados a lo largo de los presentes Términos y Condiciones, los Usuarios pueden escribirnos a la siguiente dirección electrónica hola@contactaabogado.com
                y alguien se pondrá en contacto con usted o contactarnos al teléfono</span>
            <span className={classes.normal}>o contactarnos vía telefónica: 52-55-41-60-60-61.</span>
            <span className={classes.normal}>.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XX.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jurisdicción Aplicable</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>
                Para la interpretación, cumplimiento y ejecución del presente acuerdo, las partes expresamente se someten a la jurisdicción de los tribunales competentes de la Ciudad de México, renunciando en consecuencia a cualquier fuero que en razón de su domicilio
                presente o futuro pudiera corresponderles.
            </span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <strong className={classes.normal}>XXI.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Solución de Controversias</strong>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Al aceptar estos términos y condiciones los Usuarios acuerdan libre y voluntariamente que todas las desavenencias, controversias, divergencias o cuestiones litigiosas que deriven del presente acuerdo, antes de recurrir al arbitraje, procedimiento
                judicial o a alguno de los medios alternativos de solución de controversias que se exponen a continuación, deberán interponer una queja ante CONTACTA ABOGADO.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Una vez expuesta la queja a la que se hace referencia en el párrafo precedente y no se hubiera satisfecho la pretensión de los Usuarios en un término de 45 (cuarenta y cinco) días hábiles a partir de la presentación de dicha queja, los Usuarios se
                comprometen a someter dichas controversias, divergencias o cuestiones litigiosas derivadas del presente acuerdo o relacionadas, en primer lugar, al procedimiento de Mediación ante el Centro de Justicia Alternativa es una dependencia del Tribunal
                Superior de Justicia de la Ciudad de México.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>Por su parte CONTACTA ABOGADO podrá en cualquier momento iniciar el procedimiento de solución de controversias que mejor convenga a sus intereses, a efecto de exigir el cumplimiento de cualquier obligación a cargo de los Usuarios, así como para demandar
                el pago de daños y/o perjuicios ocasionados, así como cualquier indemnización que en su caso se llegue a generar a favor de CONTACTA ABOGADO.</span>
        </p>
        <p>
            <br />
        </p>
        <p className={classes.justify}>
            <span className={classes.normal}>El uso del Sitio https://contactaabogado.com significa que usted ha leído, entendido y acepta estos Términos y Condiciones.</span>
        </p>
        <p>
            <br />
        </p>
        <p>
            <br />
        </p>
      </Element>
    </div>
  );
}

export default Terms;
